import { useEffect, useState } from "react";
import { CounterInputV2 } from "../../../FormControlsV2";
import { MessageBalloon } from "../../../MessageBalloon/Index";
import { ReactComponent as PointIcon } from "../../../../assets/svg/icons/point.svg";
import { ReactComponent as AreaIcon } from "../../../../assets/svg/icons/areaIcon.svg";
import { ReactComponent as AnimalsIcon } from "../../../../assets/svg/icons/animais.svg";
import { ButtonPressed } from "../../../Buttons/ButtonPressed";

interface InfoAnimalAddProps {
  task: ITaskAnimalResolver | undefined;
}


export default function InfoAnimalAdd(task: InfoAnimalAddProps) {
  const [taskAdd, setTaskAdd] = useState<ITaskAnimalResolver>();
  useEffect(() => {
    setTaskAdd(task.task)
  }, []);

  return (
    <>
      <div >
        <span>No retiro</span>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <AreaIcon width={30} className="iconInitialTaskInfo" />
          <div className="labelInitialTaskInfo">
            <span>{taskAdd?.area_initials}</span>
            <PointIcon width={15} />
          </div>
        </div>
      </div>

      <div >
        <span>No lote</span>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }} >
          <AnimalsIcon width={30} className="iconInitialTaskInfo" />
          <div className="labelInitialTaskInfo">
            <span>{taskAdd?.batch_initials}</span>
            <PointIcon width={15} />
          </div>
        </div>
      </div>

      <div className="containerQuestion">
        <MessageBalloon text={`${taskAdd?.task_update_type}`} />
      </div>

      {taskAdd && taskAdd.details.length > 0 && taskAdd.details.map((detail, index) => (
        detail.categories.map((category, index) => (
          <div key={index}>
            <div className="lot__title--category" style={{ marginTop: 0 }}>{category.category_description.name}</div>
            <div className="lot__subtitle--category">{category.category_description.age_description}</div>
            <CounterInputV2 name={`info-animal-add-qty-${index}`} value={Number(category.quantity ?? 0)} disabled />
          </div>
        ))
      ))}
    </>
  )
}